export default function QuoteSection() {
  return (
    <section
      className='section-bg-white-gradient mx-auto grid grid-cols-12 bg-cover bg-center bg-no-repeat px-4 py-12 md:px-16 md:py-32'
      style={{
        backgroundImage:
          "url('https://media.coolmate.me/image/March2025/mceclip2_6.jpg')",
      }}
    >
      <div className='col-span-12 mb-5 flex justify-center md:mb-10'>
        <svg
          className='max-md:w-16'
          width='104'
          height='64'
          viewBox='0 0 104 64'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M25.1441 22.2C37.4441 22.8 45.2441 31.5 45.2441 42.6C45.2441 54.3 36.5441 63.6 23.6441 63.6C9.24414 63.6 0.844142 52.5 0.844142 39.9V37.8C0.844142 21.9 11.6441 7.49998 25.4441 0.599999L25.1441 22.2ZM58.7441 39.9V37.8C58.7441 21.9 69.5441 7.49998 83.3441 0.599999L83.0441 22.2C95.3441 22.8 103.144 31.5 103.144 42.6C103.144 54.3 94.4441 63.6 81.5441 63.6C67.1441 63.6 58.7441 52.5 58.7441 39.9Z'
            fill='#1A1A1A'
          />
        </svg>
      </div>
      <div className='text-heading-6 md:text-heading-4 2xl:text-heading-2 col-span-12 text-center md:col-span-10 md:col-start-2'>
        Coolmate sinh ra để trở thành niềm tự hào của ngành dệt may Việt Nam và
        mang tới sự lựa chọn TỐT HƠN dành cho người tiêu dùng.
      </div>
    </section>
  )
}
